module.exports = __webpack_public_path__ + "img/008.c484e79e.png";